.button {
    --icon-size: 24px;
    --button-size: 48px;
    --offset: calc((var(--button-size) - var(--icon-size)) / 2 * -1);

    display: flex;
    align-items: center;
    justify-content: center;
    width: var(--button-size);
    height: var(--button-size);
    color: inherit;
    transform: translateX(var(--offset));
}

.icon {
    width: var(--icon-size);
    height: var(--icon-size);
}

.bar {
    transition:
        transform 0.2s,
        opacity 0.2s;
    transform-origin: center;
}

.topBar {
    composes: bar;
}

.middleBar {
    composes: bar;
    opacity: 1;
}

.bottomBar {
    composes: bar;
}

.iconOpen {
    .topBar {
        transform: translate3d(-3px, 3px, 0) rotate(45deg);
    }

    .middleBar {
        opacity: 0;
    }

    .bottomBar {
        transform: translate3d(-3px, -3px, 0) rotate(-45deg);
    }
}
